// Hindi translations (हिन्दी)
import type { TranslationKeys } from './en';

export const hi: TranslationKeys = {
  // Common
  common: {
    home: 'होम',
    settings: 'सेटिंग्स',
    language: 'भाषा',
    loading: 'लोड हो रहा है...',
    save: 'सहेजें',
    cancel: 'रद्द करें',
    confirm: 'पुष्टि करें',
    close: 'बंद करें',
    back: 'Back',
    continue: 'Continue',
    accept: 'Accept',
    decline: 'Decline',
    contactEmail: 'contact@zodiac-chess.com',
    companyName: 'Animal Chess Limited',
    companyCountry: 'New Zealand',
  },

  // Settings Menu
  settings: {
    header: 'सेटिंग्स',
    home: 'होम',
    howToPlay: 'कैसे खेलें',
    pieceRules: 'मोहरे के नियम',
    language: 'भाषा',
    manageSubscription: 'सदस्यता प्रबंधित करें',
    gameHistory: 'गेम इतिहास',
    analytics: 'विश्लेषण',
    premiumAccount: 'प्रीमियम खाता',
    chatEnabled: 'चैट: चालू',
    chatDisabled: 'चैट: बंद',
  },

  // Piece Rules
  pieceRules: {
    title: 'मोहरे के नियम',
    description: 'मोहरे की चाल सीखें',
    selectPiece: 'मोहरा चुनें',
    selectedLabel: 'चयनित:',
    statusLabel: 'स्थिति:',
    statusReady: 'तैयार',
    statusViewing: 'देख रहे हैं',
    movement: 'चाल',
    regularMovement: 'नियमित चाल',
    ability: 'क्षमता',
      backToSelection: 'Back to selection',
    backToHome: 'Back to home',
  },

  // Move/Ability Names
  moves: {
    movement: 'चाल',
    savage: 'जंगली',
    birdtype: 'पक्षी प्रकार',
    birdType: 'पक्षी प्रकार',
    wallBlock: 'दीवार अवरोध',
    moveblocks: 'चाल अवरोध',
    wallclimb: 'दीवार चढ़ना',
    lilypad: 'कमल पत्र',
    poisonous: 'जहरीला',
    meadow: 'घास का मैदान',
    parasiticfungi: 'परजीवी कवक',
    zombification: 'लाश बनाना',
    fungi: 'कवक',
    traverse: 'पार करना',
    capture: 'पकड़ना',
    faint: 'बेहोश',
    leap: 'छलांग',
    swing: 'झूलना',
    consume: 'खाना',
    gamble: 'जुआ',
    entangle: 'उलझाना',
    ink: 'स्याही',
    rotate: 'घुमाना',
    backstep: 'पीछे हटना',
    trample: 'रौंदना',
    charge: 'धावा',
    lane: 'लेन',
    snakestrike: 'सांप का हमला',
    shedskin: 'केंचुली उतारना',
    house: 'घर',
    plant: 'पौधा प्रकार',
    planttype: 'पौधा प्रकार',
    capturehost: 'मेजबान पकड़ना',
    contagion: 'संक्रमण',
    lonewolf: 'अकेला भेड़िया',
    hop: 'कूदना',
    decay: 'सड़ना',
    slide: 'फिसलना',
    block: 'अवरोध',
    poison: 'जहर',
    infection: 'संक्रमण',
    howl: 'गरजना',
  },

  // Animation Scenario Descriptions
  scenarios: {
    // Bear
    bearMovement: 'भालू शतरंज के राजा की तरह किसी भी दिशा में एक वर्ग चल सकता है',
    bearMovementPost: 'यह केवल मित्र मोहरों द्वारा अवरुद्ध होता है (पेड़ों को छोड़कर, भालू पेड़ों पर चढ़ सकते हैं!)',
    bearSavage: 'भालू गैंडे के अवरोध जैसी रक्षात्मक क्षमताओं को पार कर सकता है',
    bearSavagePost: 'जंगली का उपयोग करते हुए भालू किसी भी दिशा से किसी भी मोहरे को पकड़ सकता है, घातकता जोड़ता है',

    // Crane
    craneMovement: 'क्रेन किसी भी सीधी रेखा में 1 या 2 वर्ग चल सकता है',
    craneMovementPost: 'क्रेन अन्य मोहरों के ऊपर भी उड़ सकता है!',
    craneBirdType: 'पक्षी प्रकार के मोहरे बड़े या शिकारी मोहरों को पकड़ नहीं सकते',
    craneBirdTypePost: 'इसमें पेड़, गैंडे, भालू और भेड़िये शामिल हैं',

    // Frog
    frogMovement: 'मेंढक तिरछे 2 वर्ग कूदता है',
    frogMovementPost: 'केवल 1 वर्ग नहीं कूद सकता',
    frogWallBlock: 'अगर मेंढक का नियमित 2-वर्ग पथ दीवार या अन्य मोहरे द्वारा अवरुद्ध है, तो यह पकड़ नहीं सकता',
    frogWallBlockPost: 'नियमित चाल तिरछे 1 वर्ग तक छोटी हो जाती है',
    frogWallClimb: 'जब मेंढक बोर्ड की दीवार (A या E कॉलम) पर होता है तो यह ऊपर या नीचे एक वर्ग चल सकता है',
    frogWallClimbPost: 'जब तक मित्र मोहरे या मेंढक के सामने गैंडा द्वारा अवरुद्ध न हो',
    frogLilypad: 'अगर मेंढक ने अभी तक खेल में चाल नहीं चली है, तो यह पहली 3 रैंक में कहीं भी जा सकता है, एक शक्तिशाली रक्षात्मक क्षमता',
    frogLilypadPost: 'लिलीपैड जंप का उपयोग करके नियमित मोहरों को पकड़ सकता है, सिवाय गैंडे के जो उससे अधिक रैंक पर हों',
    frogPoisonous: 'अगर कोई जानवर मेंढक के मोहरे को पकड़ता है तो वे जहरीले हो जाते हैं!',
    frogPoisonousPost: 'जहरीला मोहरा ठीक होने से पहले अपनी अगली संभावित बारी छोड़ देता है',

    // Fungi
    fungiMovement: 'कवक किसी भी दिशा में एक वर्ग चल सकता है',
    fungiMovementPost: 'केवल मित्र मोहरों द्वारा अवरुद्ध',
    fungiMeadow: 'कवक दुश्मन पेड़ के मोहरों की चाल क्षमता को कम करता है',
    fungiMeadowPost: 'दुश्मन पेड़ मोहरे कवक मोहरे के 1 वर्ग के भीतर नहीं जा सकते',
    fungiParasitic: 'कवक दुश्मन पेड़ के मोहरों को जकड़ सकता है',
    fungiParasiticPost: 'जब कवक दुश्मन पेड़ के 1 वर्ग के भीतर होता है तो यह तब तक नहीं चल सकता जब तक कवक दूर नहीं जाता या पकड़ा नहीं जाता',
    fungiZombification: 'कवक दुश्मन जानवर के मोहरे को लाश बना सकता है जो इसे पकड़ता है, एक मोड़ के लिए दुश्मन जानवर को नियंत्रित करता है',
    fungiZombificationPost: 'लाश बने मोहरे को उस मोड़ के लिए कवक मोहरे के रूप में भी माना जाता है, और अगर कवक राजा था तो खेल उस मोड़ के अंत तक समाप्त नहीं होता',
    fungiFungi: 'कवक',
    fungiFungiPost: 'जैसे जहर, उलझाव और वायरस संक्रमण, हालांकि लाश बनाना अपवाद है क्योंकि लाश दूसरों को लाश बना सकती हैं!',

    // Goat
    goatMovement: 'बकरी किसी भी दिशा में एक वर्ग चल सकती है',
    goatMovementPost: 'बकरी धीरे चलती है लेकिन शक्तिशाली क्षमताएं हैं',
    goatTraverse: 'बकरी जुड़े हुए अन्य मोहरों को पार कर सकती है जो भारी चाल क्षमता बनाती है',
    goatTraversePost: 'बकरी छोटे मोहरों जैसे बेहोश बकरी या वायरस को पार नहीं कर सकती',
    goatCapture: 'बकरी शिकारियों को पकड़ नहीं सकती',
    goatCapturePost: 'जैसे भालू या भेड़िये',
    goatFaint: 'बकरी बड़े मोहरों को छोड़कर पकड़े जाने से बचने के लिए बेहोश हो सकती है जैसे पेड़ और गैंडे',
    goatFaintPost: 'बेहोश होने के दौरान विरोधी बेहोश बकरी के ऊपर "खड़ा" होकर चाल को अवरुद्ध कर सकता है',

    // Monkey
    monkeyMovement: 'बंदर किसी भी दिशा में एक वर्ग चल सकता है',
    monkeyMovementPost: 'उपयोग करने के लिए अन्य मोहरों के बिना बंदर की चाल सीमित है',
    monkeyLeap: 'बंदर चेकर्स की तरह सीधी रेखा में अन्य मोहरों के ऊपर कूद सकता है जो भारी चाल क्षमता देता है',
    monkeyLeapPost: 'लेकिन दुश्मन मोहरों के ऊपर कूदने पर बंदर को जीवित रहने के लिए पासा लुढ़काना होगा, प्रत्येक दुश्मन के लिए 1/6 पकड़े जाने का मौका!',
    monkeySwing: 'जब बंदर पेड़ के ऊपर कूदता है तो यह बोनस टर्न पाता है',
    monkeySwingPost: 'पेड़ के झूले का उपयोग करना बंदर और पेड़ के मोहरों के बीच शक्तिशाली तालमेल कॉम्बो बनाता है',
    monkeyConsume: 'बंदर कवक के मोहरे को खा सकता है और बोनस टर्न प्राप्त कर सकता है',
    monkeyConsumePost: 'अन्य बोनस टर्न के साथ संयुक्त होने पर विनाशकारी कॉम्बो की ओर ले जाता है',
    monkeyGamble: 'दुश्मनों के ऊपर कूदने के लिए पासा लुढ़काने के अलावा, बंदर को भालू को पकड़ने के लिए जुआ खेलना होगा',
    monkeyGamblePost: 'बंदर को 6-तरफा पासे पर 5 या 6 लुढ़काना होगा भालू को पकड़ने के लिए, नहीं तो खुद पकड़ा जाएगा',

    // Octopus
    octopusMovement: 'ऑक्टोपस किसी भी दिशा में एक वर्ग चलता है',
    octopusCapture: 'ऑक्टोपस केवल समकोण पर पकड़ सकता है',
    octopusCapturePost: 'ऑक्टोपस जटिल तरीकों से मोहरों को पकड़ या उलझा सकता है, इसलिए हमेशा लाल पकड़ और बैंगनी उलझाव की जांच करें!',
    octopusEntangle: 'ऑक्टोपस पास के दुश्मन मोहरों को उलझा सकता है जो उन्हें जकड़ देता है, और एक वर्ग चलकर दुश्मनों को उलझा सकता है!',
    octopusEntanglePost: 'उलझा हुआ मोहरा तब तक नहीं चल सकता जब तक ऑक्टोपस दूर नहीं जाता या पकड़ा नहीं जाता',
    octopusInk: 'ऑक्टोपस स्याही का उपयोग कर खतरनाक स्थितियों से बच सकता है और अधिकतम 3 छाया बना सकता है',
    octopusInkPost: 'दुश्मनों को भ्रमित करना और रोचक चारा और चकमा देने के खेल को सक्षम करना',

    // Penguin
    penguinMovement: 'पेंगुइन सेट दिशा में सीधी रेखा में फिसलता है और तब तक चलता रहता है जब तक दीवार या मोहरा चाल को रोक न दे',
    penguinMovementPost: 'चाल के बाद पेंगुइन उसी मोड़ के भीतर अपनी अंतिम दिशा भी सेट कर सकता है',
    penguinRotate: 'खेल की शुरुआत में पेंगुइन नीचे की ओर होता है और फिसलने से पहले घूमना होगा, जिसे सोना भी कहा जाता है',
    penguinRotatePost: 'पेंगुइन किसी भी स्थिति से चाल के बजाय घूमना चुन सकता है',
    penguinBirdType: 'पेंगुइन क्रेन की तरह सीमित पकड़ क्षमताएं हैं और बड़े या शिकारी मोहरों को पकड़ नहीं सकता जैसे पेड़, गैंडे, भालू और भेड़िये',
    penguinBirdTypePost: 'पकड़ के बाद पेंगुइन रणनीतिक स्थिति के लिए किसी भी दिशा में घूम सकता है',

    // Rhino
    rhinoMovement: 'गैंडा केवल आगे दो वर्ग चलता है',
    rhinoMovementPost: 'केवल एक वर्ग नहीं चल सकता',
    rhinoBackStep: 'गैंडा बाएं पीछे या दाएं पीछे चल सकता है',
    rhinoCharge: 'गैंडा प्रति खेल एक बार धावा क्षमता का उपयोग कर सकता है जो उसे आगे एक अतिरिक्त वर्ग जाने देता है',
    rhinoChargePost: 'विनाशकारी चाल और पकड़ क्षमता की ओर ले जाता है',
    rhinoTrample: 'गैंडा रौंदने से अपने पथ में सभी मोहरों को पकड़ता है',
    rhinoTramplePost: 'बेहोश बकरी के मोहरे सहित',
    rhinoLane: 'गैंडा रणनीतिक लेन खेल के लिए अन्य मित्र मोहरों के साथ स्थान बदल सकता है',
    rhinoLanePost: 'लेकिन केवल अगर गैंडा और मित्र मोहरा दोनों ने चाल नहीं चली है',

    // Snake
    snakeMovement: 'सांप सीधी रेखा में 2 वर्ग चल सकता है',
    snakeMovementPost: 'सांप ठीक 2 वर्ग चलता है जब तक दीवार या मित्र मोहरे द्वारा अवरुद्ध न हो',
    snakeMoveBlocks: 'अगर दीवार या बिना पकड़ के मोहरे द्वारा अवरुद्ध है तो सांप की चाल 1 वर्ग तक छोटी हो जाती है',
    snakeMoveBlocksPost: 'बीच में मोहरों के साथ भी 2 वर्ग चल सकता है',
    snakeStrike: 'अगर दुश्मन जानवर है तो सांप आगे 3 वर्ग तक हमला कर सकता है',
    snakeStrikePost: 'जब तक पथ को अवरुद्ध करने वाले बीच के मोहरे न हों',
    snakeShedskin: 'प्रति खेल एक बार, सांप केंचुली उतार सकता है और पहली रैंक पर वापस आ सकता है अगर वर्ग खाली है',
    snakeShedskinPost: 'यह पुनर्जन्म सांप को हर खेल में अतिरिक्त जीवन देता है',

    // Tree
    treeMovement: 'पेड़ आगे एक वर्ग या उसी रैंक पर बाएं या दाएं किसी भी वर्ग में जा सकता है',
    treeMovementPost: 'जब तक पथ अवरुद्ध न हो',
    treeHouse: 'पेड़ अन्य मोहरों को आवास दे सकता है और उन्हें दुश्मनों से बचा सकता है जो पेड़ पर नहीं चढ़ सकते। मोहरे जो चढ़ सकते हैं: भालू, क्रेन, मेंढक, कवक, बकरी, बंदर, ऑक्टोपस, सांप',
    treeHousePost: 'अगर पेड़ पर चढ़ सकने वाला मोहरा हमला करता है तो यह केवल आवास वाले मोहरे को पकड़ता है, पेड़ को बचाता है',
    treeTrample: 'पेड़ गैंडे की तरह वर्ग में चलने पर उस वर्ग के सभी मोहरों को पकड़ता है',
    treeTramplePost: 'बेहोश बकरी सहित',
    treePlant: 'पेड़ जानवर नहीं है बल्कि पौधा है, इसलिए कई प्रभावों से प्रतिरक्षित है',
    treePlantPost: 'जैसे जहर, लाश बनाना, उलझाव और वायरस संक्रमण!',

    // Virus
    virusMovement: 'वायरस केवल 2 वर्ग दूर जानवर द्वारा कब्जे वाले वर्ग में जा सकता है',
    virusMoveBlocks: 'वायरस दीवार के बगल में होने पर केवल 1 वर्ग चल सकता है',
    virusCaptureHost: 'जब वायरस जानवर के मोहरे पर उतरता (प्रवेश करता) है तो यह केवल संक्रमित करता है, और संक्रमित होने के दौरान सामान्य खेल जारी रख सकता है',
    virusCaptureHostPost: 'वायरस केवल संक्रमित मेजबान को छोड़ने पर मोहरे को पकड़ता है',
    virusContagion: 'वायरस एक मोड़ में कई मेजबानों को संक्रमित कर सकता है जो तेजी से फैलता है',
    virusContagionPost: 'संक्रमण के माध्यम से वायरस प्रत्येक मोड़ पर जितनी चाहें उतनी कानूनी चालें चल सकता है',

    // Wolf
    wolfMovement: 'भेड़िया शतरंज के घोड़े की तरह L-आकार में चल सकता है',
    wolfMovementPost: 'अन्य मोहरों द्वारा बाधित नहीं',
    wolfLoneWolf: 'भेड़िया',
    wolfLoneWolfPost: 'भेड़िया अकेला माना जाता है अगर केवल बेहोश बकरी या वायरस मित्र हों',
  },

  // Tutorials
  tutorials: {
    dragToExploreMobile: '👆 खोजने के लिए ड्रैग करें • ज़ूम के लिए पिंच करें',
    dragToExploreDesktop: '🖱️ खोजने के लिए ड्रैग करें • ज़ूम के लिए स्क्रॉल करें',
    previousConstellation: 'Previous constellation',
    nextConstellation: 'Next constellation',
    lockedNextHint: 'Complete at least 3 {constellation} tutorials to move to the next constellation',
    lockedStateLabel: 'Star Path',
    freeStateLabel: 'Free Roam',
    clickToFreeRoam: 'Click to free roam',
    clickForStarPath: 'Click for Star Path',
    // Tutorial popups
    failed: 'FAILED!',
    success: 'SUCCESS!',
    failedDefaultMessage: "Don't give up! Try a different approach.",
    superMessage: 'Perfect! You achieved Super completion!',
    passMessage: 'Well done! Tutorial completed!',
    tryAgain: 'Try Again',
    back: 'वापस',
    next: 'अगला',
    backToDev: 'Back to Dev',
    backToTutorials: 'Back to Tutorials',
    continue: 'Continue',
    close: 'Close',
  },

  // Sandbox
  sandbox: {
    title: 'सैंडबॉक्स',
    description: 'प्रयोग और अभ्यास',
    mode: 'मोड:',
    modeValue: 'सैंडबॉक्स',
    status: 'स्थिति:',
    statusReady: 'तैयार',
    clearBoard: 'बोर्ड साफ करें',
  },

  // Multiplayer
  multiplayer: {
    title: 'मल्टीप्लेयर',
    description: 'विरोधियों को खोजें और प्रतिस्पर्धा करें!',
    // Rematch
    rematchRequest: 'Rematch Request',
    rematchMessage: '{opponent} wants to play again!',

    // Placement matches
    placementMatches: 'प्लेसमेंट मैच',
    matchProgress: 'मैच प्रगति',
    gamesCompleted: '{games} / 10 खेल पूर्ण',
    estimatedFinalRating: 'अनुमानित अंतिम रेटिंग',
    startingRating: 'शुरुआती रेटिंग',
    matchesRemaining: '{matches} मैच शेष',
    findPlacementMatch: 'प्लेसमेंट मैच खोजें',

    // Matchmaking modes
    findMatch: 'मैच खोजें',
    competitive: 'प्रतिस्पर्धी',
    competitiveDesc: 'समान रैंक के विरोधी खोजें',
    quick: 'त्वरित मैच',
    quickDesc: 'जल्दी से प्रतिस्पर्धी मैच खोजें',
    casual: 'आकस्मिक',
    casualDesc: 'बिना रैंक - मज़े के लिए खेलें!',
    placement: 'प्लेसमेंट',
    placementDesc: 'रैंक पाने के लिए 10 मैच पूरे करें',
    startSearch: 'खोज शुरू करें',

    // Searching
    searching: 'खोज रहे हैं...',
    mode: 'मोड:',
    inQueue: 'कतार में:',
    players: 'खिलाड़ी',
    playersPlural: 'खिलाड़ी',
    cancelSearch: 'खोज रद्द करें',

    // Game info
    status: 'स्थिति:',
    ready: 'तैयार',
    selectingKing: 'राजा चुन रहे हैं',
    placingPieces: 'मोहरे रख रहे हैं',
    playing: 'खेल रहे हैं',
    gameType: 'खेल प्रकार:',
    opponent: 'विरोधी:',
    opponentElo: 'विरोधी ELO:',
    unranked: 'बिना रैंक',

    // Piece placement
    dragPieces: 'मोहरों को बोर्ड पर ड्रैग करें',
    lightPieces: 'हल्के मोहरे (आप)',
    darkPieces: 'गहरे मोहरे (आप)',

    // Waiting states
    waitingForOpponent: 'विरोधी का इंतजार...',
    waitingForKing: 'विरोधी के राजा चुनने का इंतजार...',

    // Warnings
    invalidPlacement: 'अमान्य प्लेसमेंट',
    lightTurn: 'हल्के खिलाड़ी की बारी है!',
    darkTurn: 'गहरे खिलाड़ी की बारी है!',
    onlyLightPieces: 'आप केवल हल्के मोहरे रख सकते हैं!',
    onlyDarkPieces: 'आप केवल गहरे मोहरे रख सकते हैं!',
    mustPlaceOnRow: '{color} मोहरे {row} पंक्ति पर रखे जाने चाहिए!',

    // Chat
    chat: 'चैट',
    typeMessage: 'संदेश टाइप करें...',
    send: 'भेजें',
  },

  // Main Page
  mainPage: {
    title: 'पशु शतरंज',
    subtitle: 'मनुष्यों के लिए खेल',
    playersOnline: 'अभी ऑनलाइन खिलाड़ी',
    placement: 'प्लेसमेंट',
    placementProgress: 'प्लेसमेंट',
    challengeAI: 'AI को चुनौती दें',
    multiplayer: 'मल्टीप्लेयर',
    sandbox: 'सैंडबॉक्स',
    tutorials: 'ट्यूटोरियल',
    shop: 'दुकान',
    collection: 'संग्रह',
    history: 'इतिहास',
    analytics: 'विश्लेषण',
    courses: 'पाठ्यक्रम',
    upgradeAccount: 'खाता अपग्रेड करें',
    signIn: 'साइन इन करें',
    playAsGuest: 'अतिथि के रूप में खेलें',
    welcomeBack: 'वापस स्वागत है! आप आमतौर पर इस रूप में खेलते हैं',

    // Learn the Pieces section
    learnThePieces: 'मोहरे सीखें',

    // Learn the Rules section
    learnTheRules: 'नियम सीखें',
    premiseTitle: 'आधार',
    premiseText: 'Zodiac 13-मोहरे की सूची से छिपे राजा के साथ एक शतरंज विकल्प है, अपनी अनूठी सूची चुनें फिर अपने विरोधी को धोखा दें और 5x8 बोर्ड पर उन्हें हराएं',
    selectionTitle: 'चयन',
    selectionText: 'खेल शुरू करने के लिए गुप्त रूप से राजा चुनें फिर विरोधी के साथ बारी-बारी से 5 मोहरे रखें 500 बिलियन से अधिक शुरुआती स्थितियों में से एक बनाने के लिए।',
    objectiveTitle: 'उद्देश्य',
    objectiveText: 'अपने विरोधी को पढ़ें और उनके गुप्त राजा को पकड़ें या अपने राजा को बोर्ड के दूसरी ओर ले जाकर जीत सुरक्षित करें!',
    competeTitle: 'प्रतिस्पर्धा',
    competeText: 'सीढ़ी पर अपने कौशल का परीक्षण करें, नई व्यक्तिगत तकनीक और रणनीति विकसित करें, और सर्वश्रेष्ठ के खिलाफ खेलने के लिए रैंक बढ़ाएं!',
    fullRulesButton: 'पूर्ण आधिकारिक नियमों के लिए यहां क्लिक करें',

    // FAQ section
    faqTitle: 'अक्सर पूछे जाने वाले प्रश्न',
    faqQuestion1: 'Zodiac शतरंज का विचार क्या है?',
    faqAnswer1: 'Zodiac शतरंज Bobby Fischer द्वारा Chess960 बनाने की प्रेरणा के बारे में कहे गए शब्दों से प्रेरित है। हम यांत्रिक याद के खिलाफ लड़ने और अगणित गहराई में मानव अंतर्ज्ञान का जश्न मनाने के विचार को बढ़ाना चाहते थे!',
    faqQuestion2: 'शतरंज विकल्प की आवश्यकता क्यों है',
    faqAnswer2: 'आवश्यकता नहीं है! Zodiac लोगों को शतरंज खेलने से रोकना नहीं चाहता! यह अपनी खूबियों और कमियों के साथ एक और विकल्प है, और हम आशा करते हैं कि आप इसका आनंद लें और नए खेल को सक्षम करने के लिए इस खेल को ट्यून करने में मदद करें',
    faqQuestion3: 'Zodiac शतरंज में कैसे जीतें?',
    faqAnswer3: 'आप तीन तरीकों से जीत सकते हैं: अपने विरोधी के छिपे राजा मोहरे को पकड़ें, या अपने राजा को बोर्ड के दूसरी ओर ले जाएं, या समय-नियंत्रित मैच में अपने विरोधी का समय समाप्त करें',
    faqQuestion4: 'क्या यह FAQ है?',
    faqAnswer4: 'हां, आप FAQ में सूचीबद्ध सभी प्रश्न देख सकते हैं और अधिक विवरण चाहते हैं तो प्रश्न पर क्लिक करें फिर विवरण पढ़ें जैसे कि अभी आप पढ़ रहे हैं',
    faqQuestion5: 'सामान्य खेल कितना समय लेता है?',
    faqAnswer5: 'हर खेल बहुत अलग है! कुछ खेल 2 चालों में समाप्त हो सकते हैं और कुछ 30 मिनट ले सकते हैं, सामान्यतः 5-15 मिनट!',
    faqQuestion6: 'अगर कोई कानूनी चाल नहीं चल सकता तो क्या होता है?',
    faqAnswer6: 'अगर खिलाड़ी कानूनी चाल नहीं चल सकता (गतिरोध) तो खेल ड्रॉ में समाप्त होता है। खेल दोहराव (एक ही बोर्ड स्थिति 3 बार) या खिलाड़ियों के बीच पारस्परिक समझौते से भी ड्रॉ हो सकता है!',

    // About section
    aboutButton: 'के बारे में',
    privacyPolicy: 'गोपनीयता नीति',
    developerInterface: 'डेवलपर इंटरफ़ेस',
  },

  // About Modal
  about: {
    title: 'Zodiac के बारे में',
    paragraph1: 'Zodiac एक शतरंज-जैसा बोर्ड गेम है जो LoL और DotA जैसे खेलों से मोहरा चयन तत्वों को पोकर या सामाजिक कटौती खेलों की ब्लफिंग यांत्रिकी के साथ जोड़ता है।',
    paragraph2: 'खेल का शुरुआती संस्करण 2014 में Shadow Chess के रूप में बनाया गया था। 2018 में इसे फिर से डिज़ाइन किया गया जिसमें संतुलित लेकिन अद्वितीय चाल पैटर्न और क्षमताओं के साथ मजेदार मोहरों की सूची शामिल है जो आप आज देखते हैं।',
    paragraph3: 'हमारा दृष्टिकोण सभी उपयोगकर्ता गेमप्ले डेटा को रिकॉर्ड करना है ताकि गेमप्ले को ताजा रखने और नए खेल को प्रोत्साहित करने के लिए खेल को विकसित करते रहें।',
    paragraph4: 'Zodiac के विशाल खोज स्थान, छिपी जानकारी और शुरुआती बोर्ड स्थितियों के साथ हम AI प्रभुत्व को रोकने और Zodiac को मनुष्यों के लिए खेल बनाए रखने की उम्मीद करते हैं!',
  },

  // Privacy Policy
  privacy: {
    title: 'गोपनीयता नीति',
    lastUpdated: 'अंतिम अपडेट',

    introduction: {
      title: 'परिचय',
      p1: 'Zodiac Chess ("हम", "हमारा" या "हमें") में आपका स्वागत है। हम आपकी गोपनीयता की रक्षा करने और सुरक्षित और सुखद गेमिंग अनुभव प्रदान करने के लिए प्रतिबद्ध हैं। यह गोपनीयता नीति बताती है कि जब आप हमारी वेबसाइट और गेम का उपयोग करते हैं तो हम आपकी जानकारी को कैसे एकत्र, उपयोग, प्रकट और सुरक्षित करते हैं।',
      p2: 'Zodiac Chess का उपयोग करके, आप इस नीति के अनुसार जानकारी के संग्रह और उपयोग के लिए सहमति देते हैं। यदि आप हमारी नीतियों और प्रथाओं से सहमत नहीं हैं, तो कृपया हमारी सेवाओं का उपयोग न करें।',
      contact: 'संपर्क:',
    },

    infoCollect: {
      title: 'हम जो जानकारी एकत्र करते हैं',
      accountInfo: {
        title: '1. खाता जानकारी',
        item1: 'ईमेल पता: खाता बनाने और संचार के लिए आवश्यक',
        item2: 'उपयोगकर्ता नाम: आपका चुना गया प्रदर्शन नाम',
        item3: 'पासवर्ड: एन्क्रिप्ट किया गया और सुरक्षित रूप से संग्रहीत',
      },
      gameData: {
        title: '2. गेम डेटा',
        item1: 'गेम आंकड़े: जीत, हार, ELO रेटिंग, प्लेसमेंट मैच प्रगति',
        item2: 'गेमप्ले डेटा: मोहरे चयन, चालें, उपयोग की गई रणनीतियां',
        item3: 'मैच इतिहास: खेले गए खेलों का रिकॉर्ड, विरोधियों का सामना किया',
        item4: 'इन-गेम खरीदारी: सजावटी आइटम और प्रीमियम सदस्यता स्थिति',
      },
      technicalData: {
        title: '3. तकनीकी डेटा',
        item1: 'डिवाइस जानकारी: ब्राउज़र प्रकार, ऑपरेटिंग सिस्टम',
        item2: 'उपयोग डेटा: पेज विज़िट किए, समय बिताया, उपयोग की गई सुविधाएं',
        item3: 'स्थानीय संग्रहण: भाषा प्राथमिकताएं, UI सेटिंग्स, अस्थायी गेम स्थिति',
      },
    },

    children: {
      title: 'बच्चों की गोपनीयता (COPPA अनुपालन)',
      p1: 'Zodiac Chess परिवार के अनुकूल और बच्चों सहित सभी उम्र के खिलाड़ियों के लिए उपयुक्त होने के लिए डिज़ाइन किया गया है। हम बच्चों की ऑनलाइन गोपनीयता सुरक्षा अधिनियम (COPPA) का अनुपालन करने के लिए विशेष सावधानी बरतते हैं।',
      p2: '13 वर्ष से कम उम्र के उपयोगकर्ताओं के लिए: हम अतिथि प्ले मोड का उपयोग करने की सलाह देते हैं जिसके लिए खाता बनाने या डेटा संग्रह की आवश्यकता नहीं है। अतिथि खाते टेक्स्ट चैट सुविधाओं तक पहुंच नहीं रखते, जिससे बच्चे व्यापक इंटरनेट के साथ संचार के संपर्क में नहीं आते। यदि बच्चा खाता बनाता है, तो व्यक्तिगत जानकारी एकत्र करने से पहले माता-पिता की सहमति की आवश्यकता होती है।',
      p3: 'हम सत्यापित माता-पिता की सहमति के बिना 13 वर्ष से कम उम्र के बच्चों से जानबूझकर व्यक्तिगत जानकारी एकत्र, उपयोग या साझा नहीं करते।',
      p4: 'चैट सुरक्षा: सभी अतिथि/अस्थायी खातों के लिए टेक्स्ट चैट स्वचालित रूप से अक्षम है। मानक खाता धारक किसी भी समय खाता सेटिंग्स से चैट सुविधा को अक्षम कर सकते हैं।',
      parentalRights: 'माता-पिता के पास ये अधिकार हैं:',
      right1: 'अपने बच्चे की व्यक्तिगत जानकारी की समीक्षा करें',
      right2: 'अपने बच्चे के डेटा को हटाने का अनुरोध करें',
      right3: 'अपने बच्चे की जानकारी के आगे संग्रह या उपयोग से मना करें',
      contactUs: 'इन अधिकारों का प्रयोग करने या यदि आपको विश्वास है कि आपके बच्चे ने हमें व्यक्तिगत जानकारी प्रदान की है, तो कृपया तुरंत contact@zodiac-chess.com पर संपर्क करें',
    },

    howWeUse: {
      title: 'हम आपकी जानकारी का उपयोग कैसे करते हैं',
      item1: 'गेम सेवाओं को प्रदान और सुधारें',
      item2: 'कौशल स्तर के आधार पर उचित विरोधियों से मिलान करें',
      item3: 'प्रगति, आंकड़े और उपलब्धियों को ट्रैक करें',
      item4: 'प्रीमियम सदस्यता और सजावटी वस्तुओं के लिए भुगतान प्रक्रिया करें',
      item5: 'महत्वपूर्ण सेवा घोषणाओं और अपडेट भेजें',
      item6: 'गेम संतुलन और सुविधा सुधार के लिए गेमप्ले डेटा का विश्लेषण करें',
    },

    thirdParty: {
      title: 'तृतीय-पक्ष सेवाएं',
      firebase: {
        title: 'Firebase (Google)',
        description: 'हम प्रमाणीकरण, डेटाबेस संग्रहण और मल्टीप्लेयर कार्यक्षमता के लिए Firebase का उपयोग करते हैं। Firebase अपनी गोपनीयता नीति में वर्णित कुछ डेटा एकत्र कर सकता है।',
      },
      stripe: {
        title: 'Stripe',
        description: 'हम प्रीमियम सदस्यता और इन-ऐप खरीदारी के लिए भुगतान प्रसंस्करण के लिए Stripe का उपयोग करते हैं। Stripe सभी भुगतान कार्ड जानकारी को संभालता है - हम आपके पूर्ण भुगतान विवरण नहीं देखते या संग्रहीत नहीं करते।',
      },
      netlify: {
        title: 'Netlify',
        description: 'हमारी वेबसाइट Netlify पर होस्ट की गई है, जो IP पते और एक्सेस लॉग जैसे मानक वेब होस्टिंग डेटा एकत्र कर सकती है।',
      },
      adsense: {
        title: 'Google AdSense (भविष्य)',
        description: 'हम Google AdSense के माध्यम से विज्ञापन प्रदर्शित कर सकते हैं। ये विज्ञापन वैयक्तिकरण के लिए कुकीज़ का उपयोग कर सकते हैं। बाल-निर्देशित सामग्री के लिए, हम COPPA अनुपालन के लिए केवल गैर-व्यक्तिगत विज्ञापन प्रदर्शित करते हैं।',
      },
      viewPolicy: 'गोपनीयता नीति देखें',
    },

    cookies: {
      title: 'कुकीज़ और स्थानीय संग्रहण',
      description: 'हम आपके अनुभव को बढ़ाने के लिए ब्राउज़र स्थानीय संग्रहण (कुकीज़ के समान) का उपयोग करते हैं:',
      item1: 'भाषा प्राथमिकताएं: आपकी चुनी हुई भाषा याद रखें',
      item2: 'खाता सत्र: आपको लॉग इन रखें (Firebase के साथ काम करता है)',
      item3: 'गेम सेटिंग्स: UI प्राथमिकताओं और सैंडबॉक्स सेटअप को याद रखें',
      item4: 'विज्ञापन कुकीज़: सहमति के साथ, तृतीय-पक्ष विज्ञापन सेवाएं विज्ञापन वैयक्तिकरण के लिए कुकीज़ का उपयोग कर सकती हैं',
    },

    security: {
      title: 'डेटा सुरक्षा',
      p1: 'हम आपकी जानकारी की सुरक्षा के लिए उचित सुरक्षा उपाय लागू करते हैं:',
      item1: 'पासवर्ड एन्क्रिप्शन: सभी पासवर्ड उद्योग-मानक विधियों का उपयोग करके एन्क्रिप्ट किए गए हैं',
      item2: 'सुरक्षित कनेक्शन: सभी डेटा ट्रांसमिशन के लिए HTTPS एन्क्रिप्शन',
      item3: 'Firebase सुरक्षा नियम: सख्त डेटाबेस एक्सेस नियंत्रण',
      p2: 'हालांकि, इंटरनेट पर ट्रांसमिशन की कोई विधि 100% सुरक्षित नहीं है। जबकि हम आपके डेटा की सुरक्षा के लिए प्रयास करते हैं, हम पूर्ण सुरक्षा की गारंटी नहीं दे सकते।',
    },

    retention: {
      title: 'डेटा प्रतिधारण',
      p1: 'हम आपके डेटा को इस प्रकार बनाए रखते हैं:',
      item1: 'सक्रिय खाते: जब तक आपका खाता सक्रिय है तब तक डेटा बनाए रखा जाता है',
      item2: 'निष्क्रिय खाते: यदि आपका खाता 10 वर्षों तक निष्क्रिय रहता है तो हम डेटा हटा सकते हैं',
    },

    rights: {
      title: 'आपके गोपनीयता अधिकार',
      description: 'आपके स्थान के आधार पर, आपके पास ये अधिकार हो सकते हैं:',
      access: {
        title: 'पहुंच:',
        description: 'अपने व्यक्तिगत डेटा की प्रति का अनुरोध करें',
      },
      correction: {
        title: 'सुधार:',
        description: 'डेटा सुधार का अनुरोध करें',
      },
      deletion: {
        title: 'विलोपन:',
        description: 'खाता और डेटा हटाने का अनुरोध करें',
      },
      portability: {
        title: 'डेटा पोर्टेबिलिटी:',
        description: 'पोर्टेबल प्रारूप में डेटा का अनुरोध करें',
      },
      optOut: {
        title: 'ऑप्ट-आउट:',
        description: 'विपणन संचार से ऑप्ट-आउट करें',
      },
      contact: 'इन अधिकारों का प्रयोग करने के लिए, कृपया contact@zodiac-chess.com पर संपर्क करें',
    },

    international: {
      title: 'अंतर्राष्ट्रीय उपयोगकर्ता',
      p1: 'Zodiac Chess न्यूजीलैंड से संचालित होता है। यदि आप न्यूजीलैंड के बाहर से हमारी सेवाओं तक पहुंचते हैं, तो कृपया ध्यान दें कि आपकी जानकारी न्यूजीलैंड और अन्य देशों में स्थानांतरित, संग्रहीत और प्रसंस्कृत की जा सकती है जहां हमारे सेवा प्रदाता संचालित होते हैं।',
      p2: 'हमारी सेवाओं का उपयोग करके, आप अपनी जानकारी को अपने निवास देश के बाहर के देशों में स्थानांतरित करने के लिए सहमति देते हैं, जिनके पास विभिन्न डेटा सुरक्षा कानून हो सकते हैं।',
    },

    changes: {
      title: 'इस गोपनीयता नीति में परिवर्तन',
      description: 'हम समय-समय पर इस गोपनीयता नीति को अपडेट कर सकते हैं। हम इस पृष्ठ पर नई गोपनीयता नीति पोस्ट करके और "अंतिम अपडेट" तिथि को अपडेट करके आपको परिवर्तनों के बारे में सूचित करेंगे। महत्वपूर्ण परिवर्तनों को ईमेल या हमारी वेबसाइट पर प्रमुख नोटिस के माध्यम से सूचित किया जाएगा।',
    },

    contact: {
      title: 'संपर्क करें',
      description: 'यदि आपके पास इस गोपनीयता नीति या हमारी डेटा प्रथाओं के बारे में कोई प्रश्न, चिंता या अनुरोध है, तो कृपया संपर्क करें:',
      email: 'ईमेल:',
      company: 'कंपनी:',
    },

    cookieConsent: {
      title: 'Cookie Consent & Control',
      p1: 'We believe in transparency and giving you control over your data. When you first visit Zodiac Chess, you will be presented with a cookie consent banner that allows you to choose which types of cookies you want to accept.',
      categories: {
        title: 'Cookie Categories',
        necessary: {
          title: 'Necessary Cookies',
          description: ' These cookies are essential for the website to function properly. They enable core features like authentication, game state management, and security. You cannot opt out of these cookies.',
        },
        analytics: {
          title: 'Analytics Cookies',
          description: ' These cookies help us understand how visitors interact with our website by collecting anonymous usage data through Firebase Analytics. This helps us improve the game experience.',
        },
        advertising: {
          title: 'Advertising Cookies',
          description: ' These cookies are used by Google AdSense to display personalized advertisements. Premium members never see ads, regardless of consent settings.',
        },
      },
      control: {
        title: 'How to Control Cookies',
        p1: 'You have several options to manage your cookie preferences:',
        method1: 'Cookie Banner: On your first visit, you can accept all cookies, reject optional cookies, or customize your preferences.',
        method2: 'Browser Settings: Most browsers allow you to refuse or delete cookies through their settings menu.',
        method3: 'Opt-Out Links: For advertising cookies, you can opt out of personalized ads using the links below.',
      },
      optOut: {
        title: 'Opt Out of Personalized Advertising',
        p1: 'If you would like to opt out of personalized advertising from Google and other ad networks, you can use these resources:',
        googleAds: 'Google Ad Settings - Manage Google personalized ads',
        daa: 'Digital Advertising Alliance (DAA) - Opt out of interest-based ads',
        eaa: 'European Interactive Digital Advertising Alliance (EDAA) - EU users opt-out',
      },
      moreInfo: 'For more detailed information about the cookies we use, please visit our',
      cookiePolicyLink: 'Cookie Policy',
    },
  },

  // Cookie Consent Banner
  cookieConsentBanner: {
    title: 'We Value Your Privacy',
    description: 'We use cookies to enhance your experience, analyze site usage, and show personalized ads (for free users only). You can customize your preferences at any time.',
    acceptAll: 'Accept All',
    rejectAll: 'Reject Optional',
    customize: 'Customize',
    savePreferences: 'Save Preferences',
    back: 'Back',
    necessary: 'Necessary Cookies',
    necessaryDesc: 'Required for the site to function. These cannot be disabled.',
    analytics: 'Analytics Cookies',
    analyticsDesc: 'Help us understand how you use the site to improve your experience.',
    advertising: 'Advertising Cookies',
    advertisingDesc: 'Used to show personalized ads (free users only, premium members never see ads).',
    privacyPolicy: 'Privacy Policy',
    cookiePolicy: 'Cookie Policy',
  },

  // Terms of Service
  terms: {
    title: 'सेवा की शर्तें',
    lastUpdated: 'अंतिम अपडेट',
    back: 'वापस',
    viewPrivacyPolicy: 'गोपनीयता नीति देखें',
    acknowledgment: 'Zodiac Chess का उपयोग करके, आप स्वीकार करते हैं कि आपने इन सेवा की शर्तों को पढ़ लिया है, समझ लिया है और इनसे बाध्य होने के लिए सहमत हैं।',
    acceptance: {
      title: '1. शर्तों की स्वीकृति',
      p1: 'Zodiac Chess ("सेवा") तक पहुंच और उपयोग करके, आप इन सेवा की शर्तों से बाध्य होने के लिए स्वीकार और सहमत होते हैं। यदि आप इन शर्तों से सहमत नहीं हैं, तो कृपया सेवा का उपयोग न करें।',
      p2: 'हम किसी भी समय इन शर्तों को संशोधित करने का अधिकार सुरक्षित रखते हैं। परिवर्तनों के बाद सेवा का निरंतर उपयोग संशोधित शर्तों की स्वीकृति का गठन करता है।',
    },
    description: {
      title: '2. सेवा का विवरण',
      p1: 'Zodiac Chess विशेष क्षमताओं वाले अद्वितीय पशु मोहरों के साथ एक ऑनलाइन रणनीति बोर्ड गेम है। सेवा में शामिल हैं:',
      feature1: 'AI प्रतिद्वंद्वियों के खिलाफ एकल-खिलाड़ी गेमप्ले',
      feature2: 'मल्टीप्लेयर मैचमेकिंग और प्रतिस्पर्धी खेल',
      feature3: 'इंटरैक्टिव ट्यूटोरियल और सीखने के संसाधन',
      feature4: 'खाता निर्माण और प्रगति ट्रैकिंग',
      feature5: 'वैकल्पिक प्रीमियम सदस्यता सुविधाएं',
      feature6: 'कॉस्मेटिक अनुकूलन विकल्प',
    },
    accounts: {
      title: '3. उपयोगकर्ता खाते',
      eligibility: {
        title: '3.1 पात्रता',
        p1: 'खाता बनाने के लिए आपकी आयु कम से कम 13 वर्ष होनी चाहिए। 13 वर्ष से कम आयु के उपयोगकर्ता माता-पिता की निगरानी में अतिथि प्ले मोड का उपयोग कर सकते हैं लेकिन खाते नहीं बना सकते।',
      },
      responsibilities: {
        title: '3.2 खाता सुरक्षा',
        p1: 'आप इनके लिए जिम्मेदार हैं:',
        item1: 'अपने पासवर्ड की गोपनीयता बनाए रखना',
        item2: 'आपके खाते के तहत होने वाली सभी गतिविधियां',
        item3: 'किसी भी अनधिकृत उपयोग की तुरंत हमें सूचित करना',
        p2: 'हम अनधिकृत खाता पहुंच से उत्पन्न किसी भी हानि या क्षति के लिए उत्तरदायी नहीं हैं।',
      },
      prohibited: {
        title: '3.3 निषिद्ध गतिविधियां',
        p1: 'आप निम्न नहीं कर सकते:',
        item1: 'अपना खाता दूसरों के साथ साझा करना',
        item2: 'रैंकिंग में हेरफेर के लिए कई खातों का उपयोग करना',
        item3: 'गेम खेलने के लिए बॉट, स्क्रिप्ट या स्वचालित उपकरणों का उपयोग करना',
        item4: 'अन्य खिलाड़ियों को परेशान करना, दुर्व्यवहार करना या धमकाना',
        item5: 'अनुचित लाभ के लिए बग या गड़बड़ियों का शोषण करना',
        item6: 'रिवर्स इंजीनियर करना या हमारे सोर्स कोड तक पहुंचने का प्रयास करना',
        p2: 'इन नियमों का उल्लंघन खाता निलंबन या स्थायी प्रतिबंध का परिणाम हो सकता है।',
      },
    },
    premium: {
      title: '4. प्रीमियम सदस्यता',
      billing: {
        title: '4.1 बिलिंग',
        p1: 'प्रीमियम सदस्यता Stripe के माध्यम से संसाधित की जाती है। प्रीमियम सदस्यता खरीदकर, आप हमें रद्द करने तक आवर्ती आधार पर आपकी भुगतान विधि चार्ज करने के लिए अधिकृत करते हैं।',
        p2: 'सदस्यता शुल्क हैं:',
        item1: 'मासिक योजना: आपकी खरीद तिथि की वर्षगांठ पर मासिक चार्ज',
        item2: 'वार्षिक योजना: आपकी खरीद तिथि की वर्षगांठ पर वार्षिक चार्ज',
        p3: 'सक्रिय सदस्यों को 30 दिनों की सूचना के साथ कीमतें बदल सकती हैं।',
      },
      cancellation: {
        title: '4.2 रद्दीकरण',
        p1: 'आप अपनी खाता सेटिंग्स के माध्यम से या सहायता से संपर्क करके किसी भी समय अपनी सदस्यता रद्द कर सकते हैं। रद्दीकरण आपकी वर्तमान बिलिंग अवधि के अंत में प्रभावी होता है।',
        p2: 'रद्दीकरण के बाद भी आप अपनी भुगतान अवधि के अंत तक प्रीमियम सुविधाएं बनाए रखेंगे।',
      },
      refunds: {
        title: '4.3 रिफंड',
        p1: 'मासिक सदस्यता: आंशिक महीनों के लिए कोई रिफंड नहीं। भविष्य के शुल्कों को रोकने के लिए किसी भी समय रद्द करें।',
        p2: 'वार्षिक सदस्यता: खरीद के 7 दिनों के भीतर अनुरोध करने पर पूर्ण रिफंड। 7 दिनों के बाद, रिफंड हमारे विवेकाधीन हैं।',
        p3: 'कॉस्मेटिक खरीदारी: आम तौर पर गैर-वापसी योग्य। असाधारण परिस्थितियों के लिए सहायता से संपर्क करें।',
      },
    },
    acceptable: {
      title: '5. स्वीकार्य उपयोग नीति',
      p1: 'आप सम्मानजनक और कानूनी तरीके से Zodiac Chess का उपयोग करने के लिए सहमत हैं। निषिद्ध आचरण में शामिल हैं:',
      item1: 'धोखाधड़ी, हैकिंग, या गेम मैकेनिक्स का शोषण',
      item2: 'उत्पीड़न, घृणास्पद भाषण, या भेदभावपूर्ण भाषा',
      item3: 'स्पैमिंग, विज्ञापन, या याचना',
      item4: 'अनुचित सामग्री साझा करना (यदि चैट या उपयोगकर्ता-जनित सामग्री सक्षम है)',
      item5: 'अन्य उपयोगकर्ताओं या स्टाफ सदस्यों का प्रतिरूपण',
      item6: 'सेवा को बाधित या क्षतिग्रस्त करने का प्रयास',
      p2: 'हम उल्लंघनों की जांच करने और उचित कार्रवाई करने का अधिकार सुरक्षित रखते हैं, जिसमें खाता समाप्ति और आवश्यक होने पर अधिकारियों को रिपोर्ट करना शामिल है।',
    },
    intellectual: {
      title: '6. बौद्धिक संपदा अधिकार',
      ownership: {
        title: '6.1 हमारी सामग्री',
        p1: 'गेम मैकेनिक्स, कलाकृति, एनिमेशन, ध्वनि प्रभाव, कोड और डिज़ाइन सहित लेकिन इन्हीं तक सीमित नहीं, सभी गेम सामग्री Animal Chess Limited या हमारे लाइसेंसधारकों के स्वामित्व में है।',
        p2: 'आपको केवल व्यक्तिगत मनोरंजन उद्देश्यों के लिए सेवा का उपयोग करने के लिए एक सीमित, गैर-अनन्य, गैर-हस्तांतरणीय लाइसेंस प्रदान किया गया है।',
      },
      userContent: {
        title: '6.2 उपयोगकर्ता सामग्री',
        p1: 'सामग्री (जैसे चैट संदेश, उपयोगकर्ता नाम, या प्रोफ़ाइल जानकारी) सबमिट करके, आप हमें सेवा के संबंध में उस सामग्री का उपयोग, प्रदर्शन और वितरण करने के लिए एक विश्वव्यापी, रॉयल्टी-मुक्त लाइसेंस प्रदान करते हैं।',
        p2: 'आप प्रतिनिधित्व करते हैं कि आप अपनी सबमिट की गई किसी भी सामग्री के मालिक हैं या उसके लिए आवश्यक अधिकार रखते हैं।',
      },
    },
    disclaimers: {
      title: '7. अस्वीकरण और दायित्व की सीमाएं',
      p1: 'सेवा किसी भी प्रकार की वारंटी के बिना "जैसी है" प्रदान की जाती है, चाहे व्यक्त या निहित।',
      p2: 'हम गारंटी नहीं देते कि:',
      item1: 'सेवा निर्बाध या त्रुटि-मुक्त होगी',
      item2: 'दोषों को सुधारा जाएगा',
      item3: 'सेवा वायरस या हानिकारक घटकों से मुक्त है',
      item4: 'सेवा का उपयोग करने के परिणाम आपकी अपेक्षाओं को पूरा करेंगे',
      p3: 'कानून द्वारा अनुमत अधिकतम सीमा तक, हम इनके लिए उत्तरदायी नहीं हैं:',
      item5: 'कोई भी अप्रत्यक्ष, आकस्मिक, या परिणामी क्षति',
      item6: 'लाभ, डेटा, या सद्भावना की हानि',
      item7: 'सेवा व्यवधान या डेटा हानि',
      item8: 'पिछले 12 महीनों में आपके द्वारा हमें भुगतान की गई राशि से अधिक की क्षति',
    },
    privacy: {
      title: '8. गोपनीयता',
      p1: 'सेवा का आपका उपयोग हमारी गोपनीयता नीति द्वारा भी शासित है, जो बताती है कि हम आपकी व्यक्तिगत जानकारी को कैसे एकत्र, उपयोग और सुरक्षित करते हैं।',
      p2: 'सेवा का उपयोग करके, आप गोपनीयता नीति में वर्णित हमारी डेटा प्रथाओं के लिए सहमति देते हैं।',
    },
    changes: {
      title: '9. शर्तों में परिवर्तन',
      p1: 'हम किसी भी समय इन सेवा की शर्तों को संशोधित करने का अधिकार सुरक्षित रखते हैं। हम उपयोगकर्ताओं को महत्वपूर्ण परिवर्तनों की सूचना इनके माध्यम से देंगे:',
      item1: 'पंजीकृत उपयोगकर्ताओं को ईमेल सूचना',
      item2: 'वेबसाइट पर प्रमुख सूचना',
      item3: 'इस पृष्ठ के शीर्ष पर अपडेटेड "अंतिम अपडेट" तिथि',
      p2: 'परिवर्तनों के बाद सेवा का आपका निरंतर उपयोग संशोधित शर्तों की स्वीकृति का गठन करता है।',
    },
    governing: {
      title: '10. लागू कानून',
      p1: 'ये सेवा की शर्तें न्यूज़ीलैंड के कानूनों द्वारा शासित हैं, कानून सिद्धांतों के टकराव की परवाह किए बिना।',
      p2: 'इन शर्तों या सेवा के आपके उपयोग से उत्पन्न किसी भी विवाद का समाधान न्यूज़ीलैंड की अदालतों में किया जाएगा।',
    },
    contact: {
      title: '11. संपर्क जानकारी',
      p1: 'इन सेवा की शर्तों के संबंध में प्रश्नों, चिंताओं या सहायता के लिए:',
      email: 'ईमेल:',
      company: 'कंपनी:',
      address: 'पता:',
    },
    severability: {
      title: '12. विच्छेदनीयता',
      p1: 'यदि इन शर्तों का कोई प्रावधान अप्रवर्तनीय या अमान्य पाया जाता है, तो उस प्रावधान को न्यूनतम आवश्यक सीमा तक सीमित या समाप्त किया जाएगा, और शेष प्रावधान पूर्ण रूप से लागू और प्रभावी रहेंगे।',
    },
  },

  // Cookie Policy
  cookiePolicy: {
    title: 'कुकी नीति',
    lastUpdated: 'अंतिम अपडेट',
    browserInstructions: {
      chrome: 'सेटिंग्स → गोपनीयता और सुरक्षा → कुकीज़',
      firefox: 'सेटिंग्स → गोपनीयता और सुरक्षा → कुकीज़ और साइट डेटा',
      safari: 'प्राथमिकताएं → गोपनीयता → कुकीज़ और वेबसाइट डेटा',
      edge: 'सेटिंग्स → गोपनीयता, खोज और सेवाएं → कुकीज़',
    },
    cookieTable: {
      name: 'कुकी का नाम',
      purpose: 'उद्देश्य',
      duration: 'अवधि',
      type: 'प्रकार',
    },
    relatedPolicies: {
      title: 'संबंधित नीतियां',
      description: 'हम आपके डेटा को कैसे संभालते हैं, इसके बारे में अधिक जानकारी के लिए, कृपया देखें:',
      privacy: 'गोपनीयता नीति',
      terms: 'सेवा की शर्तें',
    },

    introduction: {
      title: 'परिचय',
      p1: 'यह कुकी नीति बताती है कि जब आप हमारी वेबसाइट पर जाते हैं तो Zodiac Chess ("हम," "हमारा") कुकीज़ और समान तकनीकों का उपयोग कैसे करता है।',
      p2: 'हमारी वेबसाइट का उपयोग करके, आप इस नीति के अनुसार हमारे कुकीज़ के उपयोग के लिए सहमति देते हैं। यदि आप सहमत नहीं हैं, तो कृपया अपने ब्राउज़र सेटिंग्स में कुकीज़ को अक्षम करें या हमारी वेबसाइट का उपयोग न करें।',
    },
    what: {
      title: 'कुकीज़ क्या हैं?',
      p1: 'कुकीज़ छोटी टेक्स्ट फाइलें हैं जो आपके डिवाइस (कंप्यूटर, स्मार्टफोन, टैबलेट) पर रखी जाती हैं जब आप किसी वेबसाइट पर जाते हैं। इनका व्यापक रूप से उपयोग वेबसाइटों को कुशलता से काम करने और वेबसाइट मालिकों को जानकारी प्रदान करने के लिए किया जाता है।',
      p2: 'कुकीज़ विभिन्न उद्देश्यों की पूर्ति करती हैं, जिसमें आपकी प्राथमिकताओं को याद रखना, साइट उपयोग का विश्लेषण करना और कुछ सुविधाओं को सक्षम करना शामिल है।',
    },
    types: {
      title: 'हम किस प्रकार की कुकीज़ का उपयोग करते हैं',
      necessary: {
        title: '1. आवश्यक कुकीज़',
        description: 'ये कुकीज़ वेबसाइट के ठीक से काम करने के लिए आवश्यक हैं। इन कुकीज़ के बिना, आपके द्वारा अनुरोधित सेवाएं प्रदान नहीं की जा सकतीं।',
        examples: 'उदाहरण:',
        item1: 'प्रमाणीकरण कुकीज़ - आपको अपने खाते में लॉग इन रखती हैं',
        item2: 'सुरक्षा कुकीज़ - धोखाधड़ी गतिविधि से बचाती हैं',
        item3: 'सत्र कुकीज़ - सत्र के दौरान आपके गेम की स्थिति बनाए रखती हैं',
        item4: 'कुकी सहमति प्राथमिकताएं - आपकी कुकी पसंद याद रखती हैं',
      },
      analytics: {
        title: '2. विश्लेषण कुकीज़',
        description: 'ये कुकीज़ पेज विज़िट, बिताए गए समय और उपयोग की गई सुविधाओं के बारे में गुमनाम जानकारी एकत्र करके हमें यह समझने में मदद करती हैं कि विज़िटर हमारी वेबसाइट के साथ कैसे इंटरैक्ट करते हैं।',
        provider: 'प्रदाता: Firebase Analytics (Google)',
        purpose: 'उद्देश्य:',
        item1: 'वेबसाइट ट्रैफ़िक और उपयोगकर्ता सहभागिता मापना',
        item2: 'लोकप्रिय सुविधाओं और पेजों की पहचान करना',
        item3: 'उपयोगकर्ता जनसांख्यिकी (आयु सीमा, सामान्य स्थान) समझना',
        item4: 'वेबसाइट प्रदर्शन और उपयोगकर्ता अनुभव में सुधार करना',
      },
      advertising: {
        title: '3. विज्ञापन कुकीज़',
        description: 'ये कुकीज़ आपके लिए प्रासंगिक विज्ञापन प्रदर्शित करने के लिए उपयोग की जाती हैं। वे यह भी सीमित करती हैं कि आप कितनी बार एक विज्ञापन देखते हैं और विज्ञापन अभियानों की प्रभावशीलता मापने में मदद करती हैं।',
        provider: 'प्रदाता: Google AdSense',
        purpose: 'उद्देश्य:',
        item1: 'आपकी रुचियों के आधार पर व्यक्तिगत विज्ञापन दिखाना',
        item2: 'विज्ञापन प्रदर्शन और सहभागिता मापना',
        item3: 'एक ही विज्ञापन को बार-बार दिखाने से रोकना',
        note: 'नोट: प्रीमियम सदस्य कुकी सेटिंग्स की परवाह किए बिना कभी विज्ञापन नहीं देखते।',
      },
    },
    firstThird: {
      title: 'प्रथम-पक्ष बनाम तृतीय-पक्ष कुकीज़',
      firstParty: {
        title: 'प्रथम-पक्ष कुकीज़',
        description: 'ये सीधे Zodiac Chess द्वारा सेट की गई कुकीज़ हैं। हम इनका उपयोग आवश्यक साइट कार्यक्षमता, प्रमाणीकरण और आपकी प्राथमिकताओं को याद रखने के लिए करते हैं।',
      },
      thirdParty: {
        title: 'तृतीय-पक्ष कुकीज़',
        description: 'ये हमारे द्वारा उपयोग की जाने वाली बाहरी सेवाओं द्वारा सेट की गई कुकीज़ हैं, जैसे Google Analytics और Google AdSense। तृतीय-पक्ष कुकीज़ उन प्रदाताओं की गोपनीयता नीतियों के अधीन हैं।',
      },
    },
    specific: {
      title: 'विशिष्ट कुकीज़ जो हम उपयोग करते हैं',
      tableHeader: 'नीचे हमारी वेबसाइट पर उपयोग की जाने वाली कुकीज़ की विस्तृत सूची है:',
    },
    control: {
      title: 'कुकीज़ को कैसे नियंत्रित करें',
      consent: {
        title: '1. कुकी सहमति बैनर',
        description: 'जब आप पहली बार हमारी वेबसाइट पर जाते हैं, तो आपको एक कुकी सहमति बैनर दिखाई देगा। आप कर सकते हैं:',
        item1: 'सभी स्वीकार करें - सभी कुकीज़ की अनुमति दें (आवश्यक, विश्लेषण और विज्ञापन)',
        item2: 'वैकल्पिक अस्वीकार करें - केवल आवश्यक कुकीज़ की अनुमति दें (कोई विश्लेषण या विज्ञापन नहीं)',
        item3: 'कस्टमाइज़ करें - ठीक से चुनें कि आप किस प्रकार की कुकीज़ की अनुमति देना चाहते हैं',
      },
      browser: {
        title: '2. ब्राउज़र सेटिंग्स',
        description: 'अधिकांश वेब ब्राउज़र आपको अपनी सेटिंग्स के माध्यम से कुकीज़ को नियंत्रित करने की अनुमति देते हैं। आप कर सकते हैं:',
        item1: 'सभी कुकीज़ ब्लॉक करें',
        item2: 'केवल प्रथम-पक्ष कुकीज़ स्वीकार करें',
        item3: 'प्रत्येक ब्राउज़िंग सत्र के बाद कुकीज़ हटाएं',
        item4: 'व्यक्तिगत कुकीज़ देखें और हटाएं',
        links: 'यहां लोकप्रिय ब्राउज़रों के लिए कुकी प्रबंधन के लिंक हैं:',
      },
      optOut: {
        title: '3. ऑप्ट-आउट टूल्स',
        description: 'विज्ञापन कुकीज़ के लिए विशेष रूप से, आप व्यक्तिगत विज्ञापनों से ऑप्ट आउट कर सकते हैं:',
        googleLink: 'Google विज्ञापन सेटिंग्स',
        googleDesc: ' - Google व्यक्तिगत विज्ञापन प्रबंधित करें',
        daaLink: 'डिजिटल एडवर्टाइजिंग अलायंस (DAA)',
        daaDesc: ' - रुचि-आधारित विज्ञापन से ऑप्ट आउट करें',
        edaaLink: 'यूरोपीय इंटरैक्टिव डिजिटल एडवर्टाइजिंग अलायंस (EDAA)',
        edaaDesc: ' - EU-विशिष्ट ऑप्ट-आउट टूल',
      },
    },
    impact: {
      title: 'कुकीज़ अक्षम करने का प्रभाव',
      p1: 'यदि आप कुकीज़ अक्षम या अस्वीकार करते हैं, तो कृपया ध्यान दें कि:',
      item1: 'वेबसाइट के कुछ हिस्से ठीक से काम नहीं कर सकते',
      item2: 'आपको प्रत्येक विज़िट पर अपनी प्राथमिकताएं फिर से दर्ज करनी पड़ सकती हैं',
      item3: 'आप अपने खाते से लॉग आउट हो सकते हैं',
      item4: 'साइट के काम करने के लिए आवश्यक कुकीज़ जरूरी हैं - उन्हें अक्षम करने से आप मुख्य सुविधाओं का उपयोग नहीं कर पाएंगे',
    },
    updates: {
      title: 'इस कुकी नीति में अपडेट',
      p1: 'हम समय-समय पर इस कुकी नीति को अपनी प्रथाओं में परिवर्तन या कानूनी, नियामक या परिचालन कारणों से प्रतिबिंबित करने के लिए अपडेट कर सकते हैं।',
      p2: 'हम इस पेज के शीर्ष पर "अंतिम अपडेट" तिथि को अपडेट करके महत्वपूर्ण परिवर्तनों के बारे में आपको सूचित करेंगे। कृपया इस नीति की समय-समय पर समीक्षा करें।',
    },
    contact: {
      title: 'हमसे संपर्क करें',
      p1: 'यदि आपके पास कुकीज़ के हमारे उपयोग या इस कुकी नीति के बारे में प्रश्न हैं, तो कृपया हमसे संपर्क करें:',
      email: 'ईमेल:',
      company: 'कंपनी:',
    },
  },

  // Game
  game: {
    yourTurn: 'Your Turn',
    opponentTurn: "Opponent's Turn",
    victory: 'Victory!',
    defeat: 'Defeat',
    draw: 'Draw',
    resign: 'Resign',
    offerDraw: 'Offer Draw',
  },

  // Game Info
  gameInfo: {
    title: 'Game Info',
    sandboxMode: 'Sandbox Mode',
    lightTurn: "Light's turn",
    darkTurn: "Dark's turn",
    yourTurn: 'Your turn',
    opponentTurn: "Opponent's turn",
    aiThinking: 'AI thinking...',

    // Selection states
    selecting: 'Selecting {piece}',
    observing: 'Observing {piece}',
    selectingZombified: 'Selecting zombified enemy {piece}',
    selectionLocked: 'Selection locked on {piece}',
    selectionLockedPenguin: 'पेंगुइन',

    // Hints
    clickToFaint: 'Click on {piece} to faint',
    clickToRotate: 'Click on the {piece} to rotate',
    clickToInk: 'Click on the {piece} to ink',
    zombifiedWarning: '⚠️ While zombified, {piece} rotates before moving!',

    // Monkey bonus turn
    monkeySwing: 'Monkey completed swing, please move your Monkey to complete bonus turn',
    monkeyConsume: 'Monkey consumed fungi, please move your Monkey to complete bonus turn',

    // Virus bonus turn
    virusInfecting: 'Virus is infecting, continue turn or click on virus to end turn',

    // Penguin bonus turn
    penguinRotate: 'Penguin completed slide - please choose final rotation direction',
    penguinCaptureRotate: 'Penguin completed capture - please choose final rotation direction',
    penguinZombified: 'Zombified Penguin rotated - complete turn with slide/capture (zombification will end)',

    // Capture restrictions
    cannotCapture: '{piece} cannot capture: {targets}',
    cannotInfect: '{piece} cannot infect: {targets}',
    cannotEntangle: '{piece} cannot entangle: {targets}',
    monkeyBearRoll: '{piece} must roll 5-6 to capture enemy {target}',
    cannotBeCapturedBy: '{piece} cannot be captured by: {attackers}',
    monkeyNeedsRoll: '{attacker} needs to roll 5-6 to capture',

    // Meadow warning (Tree immobilization)
    meadowWarning: '{piece} is immobilized by enemy {fungi}',
    rhinoChargeWarning: '{piece} charge does not affect: {targets}',
    snakeStrikeWarning: '{piece} strike does not affect: {targets}',
  },

  // Piece names
  pieces: {
    Bear: 'भालू',
    Crane: 'सारस',
    Frog: 'मेंढक',
    Fungi: 'कवक',
    Goat: 'बकरी',
    Monkey: 'बंदर',
    Octopus: 'ऑक्टोपस',
    Penguin: 'पेंगुइन',
    Rhino: 'गैंडा',
    Snake: 'साँप',
    Tree: 'पेड़',
    Virus: 'वायरस',
    Wolf: 'भेड़िया',
  },

  // Short poetic vibe descriptions for landing carousel — one per variant
  pieceVibes: {
    Bear:    { light: 'Few dare approach',                   dark: 'Nothing impedes her hunger' },
    Crane:   { light: 'Sailing above, quieter than the wind',      dark: 'It circles. It waits. The lonely never return home' },
    Frog:    { light: 'Lazing on the lily pad',       dark: 'Take the colors as a warning' },
    Fungi:   { light: 'The meadow-maker',         dark: 'Consume and see who has been consumed' },
    Goat:    { light: 'Catch me on the cliff side',   dark: 'The corpse that blinks' },
    Monkey:  { light: 'Branch to branch to foe, laughing all the way',               dark: 'Roll the bones. Smiles either way' },
    Octopus: { light: 'Soft arms, razor sharp hooks, never releasing its grip',  dark: 'A bloom of black water. The shape inside is gone' },
    Penguin: { light: 'A harmless little thing in a tiny black coat',        dark: 'Slow and cute, right?' },
    Rhino:   { light: 'Waiting to face down a challenger', dark: 'Lock eyes at your peril' },
    Snake:   { light: 'Changing endings like outfits',                               dark: 'Do not tread near me' },
    Tree:    { light: 'A haven amongst the beasts',             dark: 'Standing where the dead stood. Still standing' },
    Virus:   { light: 'The battle for pandoras box',         dark: 'They feel triumph, then a cough, then silent disbelief' },
    Wolf:    { light: 'The alpha of his pack',  dark: 'When the pack is gone. What remains excites' },
  },


  // Move Context (piece descriptions)
  moveContext: {
    title: 'Move Context',
    emptyState: 'Select an ability from the left panel to view detailed information.',
  },

  // Challenge AI
  challengeAI: {
    // Title and tagline
    title: 'AI ARENA',
    tagline: 'Pick an AI to Battle or watch AI duke it out!',

    // Player labels
    lightPlayer: 'Light Player',
    darkPlayer: 'Dark Player',
    humanPlayer: 'Human Player',
    aiPlayer: 'AI',
    difficulty: 'Difficulty',
    difficultyEasy: 'Easy',
    difficultyMedium: 'Medium',
    difficultyHard: 'Hard',

    // AI Models
    aiGaia: 'Gaia',
    aiSentinel: 'Sentinel',
    aiAlchemist: 'Alchemist',
    aiZenith: 'Zenith',
    aiTrapper: 'Trapper',
    aiHunter: 'Hunter',
    aiWisp: 'Wisp',
    aiCreature: 'Creature',
    aiWeaver: 'Weaver',

    // Time Frames
    timeFast: 'Fast',
    timeStandard: 'Standard',
    timeDeep: 'Deep',

    // Thinking time
    thinkingTime: 'Thinking Time',

    // Info box
    matchupLabel: 'Matchup:',
    statusLabel: 'Status:',
    statusPaused: 'PAUSED',
    statusAIThinking: 'AI Thinking...',
    statusInGame: 'In Game',
    statusReady: 'Ready',
    matchupLocal2P: 'Local 2P',
    matchupPlayerVs: 'Player vs',
    matchupVsPlayer: 'vs Player',

    // Buttons
    startButton: 'Start',
    startRandomButton: 'Start Random',
    newGameButton: 'New Game',
    resumeButton: 'Resume',
    pauseButton: 'Pause',
    pauseQueuedButton: 'Pause (queued...)',
    viewKingsButton: 'View Kings',
    hideKingsButton: 'Hide Kings',
    viewKingsQueuedButton: 'View Kings (queued...)',
    hideKingsQueuedButton: 'Hide Kings (queued...)',
    homeButton: 'Home',
    toggleKingVisibility: 'Toggle king visibility',

    // Warning modal
    invalidPlacement: 'Invalid Placement',
    okButton: 'OK',
    warningLightTurn: "It's Light player's turn to place a piece!",
    warningDarkTurn: "It's Dark player's turn to place a piece!",
    warningLightRow: 'Light pieces must be placed on row 0 (your home row)!',
    warningDarkRow: 'Dark pieces must be placed on row 7 (your home row)!',
    warningOccupied: 'This square is already occupied! Choose an empty square.',
    warningKingRequired: 'You must place your king ({kingType}) before placing your 5th piece!',

    // Piece selection
    dragPieces: 'Drag pieces to the board',
    lightPieces: 'Light Pieces',
    darkPieces: 'Dark Pieces',

    // Mobile
    selectYourKing: 'Select Your King',
    selectPieceToPlace: 'Select Piece to Place',
    moveHistory: 'Move History',
    historyButton: 'History',
    backButton: 'Back',
    lightTurn: "Light's turn",
    darkTurn: "Dark's turn",
  },

  // Donation
  donation: {
    title: 'Support Zodiac Chess',
    supportDevelopment: 'Support Development',
    story1: "Hi! Your support helps me continue improving this unique game! Adding new features, maintaining servers, and keeping Zodiac Chess free for the community.",
    story2: "Even a small donation makes a huge difference and keeps this project alive. Thank you for being part of the Zodiac Chess journey :)",
    selectAmount: 'Choose Amount',
    customAmount: 'Or enter custom amount:',
    total: 'Total:',
    donateButton: 'Donate Now',
    processing: 'Processing...',
    disclaimer: 'Donations support development and server costs. Thank you for your generosity!',
    invalidAmount: 'Please enter a valid amount greater than $0',
    error: 'There was an error processing your donation. Please try again.',
  },

  // Game End Popup
  gameEnd: {
    victory: 'VICTORY!',
    defeat: 'DEFEAT!',
    draw: 'DRAW!',
    wonBy: 'Won by {condition}',
    lostBy: 'Lost by {condition}',
    drawBy: 'Draw by {condition}',
    youCapturedTheirKing: 'You captured their {piece} King!',
    yourKingWasCaptured: 'Your {piece} King was captured!',
    rematchButton: 'Rematch',
    backButton: 'Back',
    conditions: {
      kingslayer: 'Kingslayer',
      race: 'Race Victory',
      timeout: 'Timeout',
      threefold: '3x Repetition',
      noMoves: 'No Valid Moves',
      draw: 'Draw',
    },
  },

  // Upgrade Modal
  upgrade: {
    title: 'Upgrade to Premium',
    accountRequired: 'You need to create a permanent account before upgrading to premium.',
    createAccountPrompt: 'Create an account to save your progress and unlock premium features!',
    subtitle: 'Unlock powerful features to enhance your Zodiac Chess experience!',
    features: {
      history: 'Account History',
      historyItem1: 'Store and recall all your previous games',
      historyItem2: 'Replay your old games from anypoint to evaluate strategy',
      historyItem3: 'Use deep analytics to analyse board positions and brilliant move opportunities',
      analytics: 'Analytics',
      analyticsItem1: 'Get access to game stats',
      analyticsItem2: 'Analyse users piece and king selection across tonnes of metrics',
      analyticsItem3: 'Find out what metas are popular and whats working!',
      course: 'Course',
      courseItem1: 'Get access to upto date courses to develop your skill',
      courseItem2: "Learn meta's and concepts from the pro's",
      courseItem3: 'Get tips on your own game play to analyse your own weaknesses',
    },
    createAccount: 'Create Account',
    upgradeNow: 'Upgrade Now',
    cancel: 'Cancel',
  },

  // Premium Modal
  premium: {
    title: 'Premium Feature',
    accessDenied: 'Sorry you do not have a premium account, you do not have access to these features yet!',
  },

  // Stripe Error Page
  stripe: {
    errorTitle: 'Oops! Something Went Wrong',
    errorMessage: "We encountered an issue processing your payment. Don't worry, you haven't been charged.",
    whatHappened: 'What happened?',
    notCompleted: "Your payment wasn't completed. This could be due to:",
    reasons: {
      cancelled: 'Payment was cancelled',
      declined: 'Card was declined',
      connection: 'Connection issue during checkout',
      expired: 'Session expired',
    },
    whatToDo: 'What can you do?',
    actions: {
      tryDifferentCard: 'Try again with a different card',
      tryDifferentCardDesc: 'Use another payment method',
      retryPayment: 'Retry the payment',
      retryPaymentDesc: 'Sometimes a simple retry works',
      checkBank: 'Check with your bank',
      checkBankDesc: 'Ensure your card has sufficient funds',
    },
    tryAgain: 'Try Upgrading Again',
    returnHome: 'Return to Main Page',
    contactSupport: 'Need help? Contact support at support@zodiac-chess.com',
  },


  // How To Play - Learn the Pieces
  howToPlay: {
    // Section titles
    whatIsZodiac: 'What is it about?',
    gameSetup: 'Game Setup',
    basicRules: 'Basic Rules',
    backButton: 'BACK',
    homeButton: 'Home',
    fullRules: 'Full Rules',

    // What is Zodiac section
    whatIs: {
      p1: 'Zodiac is a two player abstract strategy game based off of Chess, Poker and DotA.',
      p2: 'It was created in 2014 as a crude version of itself called "Shadow Chess" based off its central principal of a secret king',
      p3: 'Later in 2018 it was redesigned to involve a roster of novel pieces with unique movement patterns and abilities',
      p4: "Zodiac's goal is to celebrate human intuition and novel play. To drive success toward a players ability to bluff and adapt to unfamiliar situations and create a nuanced set of challenges for the ever growing strength of AI",
      p5: "Another goal of Zodiac is to be a game for humans! With a very large search space for play, hidden information, win obfuscation and a changing roster of pieces over time. Zodiac wants to be a player data driven game that keeps creativity mainstay and staves off AI dominance",
      p6: 'We hope you stick around and see where this journey takes us',
    },

    // Setup section
    setup: {
      p1: "Players play a zodiac version of paper, scissors, rock to see who goes first!",
      p2: 'From there, select a piece to be your "King" your opponent won\'t know which one you have chosen.',
      p3: 'Then pick 5 pieces to play with, they all have different abilities, cohesion, strengths and weaknesses!',
      p4: 'Once you are both done the game will begin.',
      p5: 'Simply click on a piece to see where it can move to or click on any unhighlighted square to deselect the piece.',
      p6: 'Good luck!',
    },

    // Basic Rules section
    rules: {
      intro: 'The game of Zodiac is played by two players on a rectangle board made up of 40 squares (5 by 8).',
      toWinTitle: 'To win:',
      toWin1: 'Capture the opponents King',
      toWin2: '"Race" your King across the board',
      toWin3: 'Have your opponents timer expire',
      toWin4: 'Have your opponent surrender',
      drawTitle: 'A draw occurs',
      draw1: 'When a players king is still uncaptured and they cannot make any legal move, or;',
      draw2: 'The same board position is repeated three times',
    },

    // Piece tutorials
    tutorials: {
      bear: {
        desc1: 'Regular movement - The Bear can move one square in any direction',
        desc2: 'The Bear\'s ability "Savage" allows it to capture any piece regardless of defensive abilities',
        desc3: 'The bear is a "large" piece and a "predator" piece meaning many of the other Zodiacs cannot capture it!',
      },
      crane: {
        desc1: 'The Crane can move 1 or 2 in any straight line for its regular movement',
        desc2: "The Crane cannot capture any 'large' or 'predator' pieces",
      },
      frog: {
        desc1: 'The frog can jump 2 on diagonals for its regular movement, even over other pieces!',
        desc2: "If the frog's regular movement is blocked by a wall or a piece it cannot capture, its regular movement is shortened to 1 square diagonally",
        desc3: "If the frog has yet to make a move in the game, it is on its 'lily pad' and can move to any of the first 3 ranks as a defensive movement",
        desc4: 'If a piece captures a frog, it becomes poisoned and cannot make any move for its next available turn',
        desc5: "The frogs special movement is 'wall climb' if a frog is beside the edge of the board, it can also move one up or down",
      },
      fungi: {
        desc1: 'The Fungi can move one in any direction for its regular movement',
        desc2: "The fungi's ability 'meadow' prevents a tree from moving if it is within one square of the fungi and does not allow a tree to move within one square of the enemy fungi",
        desc3: "When captured the fungi applies a 'zombie' effect to any animal piece that captured it",
        desc4: 'While zombified, the fungi controls the piece for the following turn and acts as the piece, meaning if the fungi was your king, you can still win by race victory or capturing the enemy king within that round',
      },
      goat: {
        desc1: 'The goat can move one in any direction for its regular movement',
        desc2: "The goats ability 'traverse' allows it to hop across linked pieces and then move, it cannot capture any piece on a traverse",
        desc3: "The goat cannot capture any 'predators'",
        desc4: "The goat can use a special ability called 'faint' to make itself appear dead",
        desc5: "While fainted, the goat is unable to be captured by most pieces but cannot move if another piece is 'standing' on it (on the same square)",
      },
      monkey: {
        desc1: 'The monkey can move one in any direction for its regular movement',
        desc2: "The monkey can 'leap' over friendly and enemy pieces like a checkers piece if the formation allows it",
        desc3: 'If the monkey does leap over an enemy piece it must roll a dice to not be captured! One danger point per enemy piece it leaps in a single line',
        desc4: 'The monkey CAN capture a bear if it decides to gamble to attack it, on a 1-4 roll on a six sided dice, the Monkey is captured, on a 5 or 6, the Monkey captures the bear',
        desc5: "The monkey has two abilities - 'swing' and 'consume' on a swing (a leap ending over a tree) the monkey gains an extra movement, on a consume of any fungi, the monkey also gains one extra movement before its turns end",
      },
      octopus: {
        desc1: 'The octopus can move one in any direction for its regular movement',
        desc2: 'The octopus may only capture on orthagonal squares',
        desc3: "The octopus can use its ability 'entangle' on any animal piece on diagonal squares",
        desc4: 'The octopus may make any move AND entangle in one turn',
        desc5: "The octopus has an ability called 'ink' with this ability it can move to any orthagonal square and place 'shadows' on the other 3 orthagonal squares if they are not occupied or off of the board. To the opponent for the round following the 'ink' ability the shadows and real octopus are indistinguishable",
      },
      penguin: {
        desc1: "The penguin has an ability called 'rotate' it is the only piece that has a set direction and may use the 'rotate' move to redirect its direction for its turn",
        desc2: "For the penguins regular movement 'slide' it must move to the furthest point in the direction it is facing and once there, it may use a rotate before its turns end to redirect its direction",
        desc3: "The penguin cannot capture any 'large' or 'predator' pieces. It can capture any other piece within one square of itself and use a rotate ability after the capture",
      },
      rhino: {
        desc1: "The rhino can move 'back left', 'back right' or two forward as part of its regular movement",
        desc2: "The rhino has an ability called 'trample' where captures ALL pieces in the path of its movement",
        desc3: 'Once per game a rhino may perform a charge of 3 squares ahead if any animal is present in any of the 3 squares directly infront of the rhino',
        desc4: 'The rhino has a special ability called "rhino defence" where the rhino cannot be captured from \'the front\'',
        desc5: "The rhino has an ability called 'lane' where if it has not moved and the friendly piece directly to its left or right has not moved, it can switch places with that piece for its turn",
      },
      snake: {
        desc1: 'The snake can move 2 squares only in orthagonal directions, including through other pieces for its regular movement',
        desc2: 'If its regular movement is blocked by a wall or a piece it cannot capture, its regular movement becomes 1',
        desc3: 'The snake has an ability called "strike" where if an animal is exactly 3 squares ahead of it and there are no pieces between, it can \'strike\' forward and capture that animal',
        desc4: 'The snake has an ability called "shed" where once per game if the snake is captured, it will return to the first rank of the board, in the same column, as if it had a second life. If the first rank is not a valid square for the snake to move to, it is permanently captured',
      },
      tree: {
        desc1: 'The tree may move one forward or unlimitedly side to side if not blocked by any other piece',
        desc2: "The tree has a special ability called 'house' where any piece that can 'climb' tree's may sit on top of the tree piece. If an enemy piece attacks a tree with a housed piece, the housed piece is captured and the tree houses the enemy piece",
        desc3: 'When a piece is housed in the tree, if an enemy piece cannot climb the tree, both the tree and the housed piece are protected from capture',
      },
      wolf: {
        desc1: 'The wolf moves in an L shape like a knight in chess for its regular movement',
        desc2: "If the wolf is the last piece on the board* it's ability 'lone wolf' is activated and it moves in a long L instead as pictured above. *The wolf will enter lone if on a team with a fainted goat or infecting virus",
      },
      virus: {
        desc1: "The virus may move 2 squares in any straight line for its regular movement, it does not capture but uses its ability 'infect' to cause the piece to be infected rather than captured",
        desc2: "The virus can only move to any animal piece, if blocked by a wall, the virus's regular movement is only 1 square",
        desc3: "When an animal piece is 'infected' if the virus leaves the infected piece in to another piece, the piece it left is captured and the new piece is 'infected'",
        desc4: "The virus has an ability called 'infectious' which allows the virus to complete as many valid moves in one move as it likes, capturing multiple animals in one turn",
        desc5: "While not 'infecting' the virus can be captured like any other piece, if an animal captures an infected piece, it becomes infected",
      },
    },
  },
};
